import { DOCUMENT, Directive, Inject } from '@angular/core';

@Directive({
    standalone: true,
    selector: '[appScrollTop]',
})
export class ScrollTopDirective {
    constructor(@Inject(DOCUMENT) private document: Document) {
        this.scrollToTop();
    }

    scrollToTop(): void {
        const contentElm = this.document.querySelector('#sidenav-content');
        if (contentElm) {
            contentElm.scrollTop = 0;
        }
    }
}
